import { safeParseResponse } from '../../utils';
import { authorizedPost } from '../api-authorization/AuthorizedFetch';

const createPulse = async () => {
    const response = await authorizedPost("api/engagement-pulses", { });
    const { engagementPulseId } = await safeParseResponse(response);

    return engagementPulseId;
}

export default createPulse;